import React from 'react'
import { Route, Switch } from 'react-router-dom'
import './App.css';
import Header from './components/Header';
import Main from './components/Main'
import Footer from './components/Footer'
import Obrazovanje from './obrazovanje/Obrazovanje';
import Onama from './o-nama/O-nama';
import Kontakt from './kontakt/Kontakt';
import OsnovniPodaci from './osnovni-podaci/OsnovniPodaci';
import Galerija from './o-nama/galerija/Galerija';
import Prekvalifikacija from './obrazovanje/prekvalifikacija';
import Doskolovanje from './obrazovanje/doskolovanje';
import Osposobljavanje from './obrazovanje/Osposobljavanje';
import Konkurs from './components/konkurs';

const App = () => {
  return (
    <div className="App">
      <Switch>
          <Route path="/obrazovanje">
            <Obrazovanje />
          </Route>
        <Route path="/o-nama">
          <Onama />
        </Route>
        <Route path="/kontakt">
          <Kontakt />
        </Route>
        <Route path="/osnovni-podaci">
          <OsnovniPodaci />
        </Route>
        <Route path="/Obrazovanje">
          <Obrazovanje />
        </Route>
        <Route path="/galerija">
          <Galerija />
        </Route>
        <Route path="/prekvalifikacija">
          <Prekvalifikacija />
        </Route>
        <Route path="/dokvalifikacija">
          <Doskolovanje />
        </Route>
        <Route path="/osposobljavanje">
          <Osposobljavanje />
        </Route>
        <Route path="/konkurs">
          <Konkurs />
        </Route>
        <Route path="/">
          <Header />
          <Main />
          <Footer />
        </Route>
      </Switch>
    </div>
  );
}

export default App;
